import React from 'react'
import styled from 'styled-components'

interface Props {
  placeholder: string
  name: string
  onChange: React.ChangeEventHandler<HTMLInputElement>
  questionId: string
  value: string
}

const TextField: React.FC<Props> = ({ placeholder, onChange, name, questionId, value }) => (
  <TextFieldContainer>
    <input
      type="text"
      placeholder={placeholder}
      name={name}
      onChange={onChange}
      value={value}
      aria-labelledby={questionId}
    />
  </TextFieldContainer>
)

const TextFieldContainer = styled.div`
  border-radius: 4px;
  box-shadow: 0 4px 13px 0 rgba(0, 0, 0, 0.12);
  width: 100%;
  margin-bottom: 20px;
  border: solid 1px ${({ theme }) => theme.lightGrey};

  & input {
    border: none;
    display: block;
    font-size: 1.125rem;
    width: 100%;
    font-family: 'Circular', sans-serif;
    padding: 30px;

    &::placeholder {
      color: ${({ theme }) => theme.textColor};
      opacity: 0.5;
    }

    &:focus {
      outline: none;
      box-shadow: 0 4px 13px 0 rgba(0, 0, 0, 0.32);
    }
  }
`

export default TextField
